import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.66671 13.6641H3.00004C2.63185 13.6641 2.33337 13.3656 2.33337 12.9974V5.66406M2.33337 5.66406V3.66406C2.33337 3.29587 2.63185 2.9974 3.00004 2.9974H13C13.3682 2.9974 13.6667 3.29587 13.6667 3.66406V5.66406M2.33337 5.66406H13.6667M13.6667 5.66406V8.33073M5.00004 2.9974V1.66406M11 2.9974V1.66406M14.3334 10.3307L11.2223 14.3307L9.66671 12.7307",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }